import React, { useState, useContext } from "react";
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import "../styles/LoginRegister.css";

function LoginRegister() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [isLogin, setIsLogin] = useState(true); // مدیریت تب‌ها
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const { setUser } = useContext(UserContext);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // آدرس API رو تغییر بده به آدرس درست سرور خودت
    const url = isLogin ? `${API_BASE_URL}/Auth/login` : `${API_BASE_URL}/Auth/register`;

    if (!isLogin && formData.password !== formData.confirmPassword) {
      setError("The password and its repetition are not the same!");
      return;
    }

    const userData = isLogin
      ? { email: formData.email, password: formData.password }
      : { username: formData.username, email: formData.email, password: formData.password };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData),
      });

      
      if (!response.ok) {
          const errorMessage = await response.text();
          throw new Error(errorMessage  || "A problem has occurred");
        }

        
        if (!isLogin)
            setIsLogin(true)
        else{
            const data = await response.json();
            // ذخیره توکن در کش
            localStorage.setItem("userToken", data.token);

            try {
              const profileResponse = await fetch(`${API_BASE_URL}/User/profile`, {
                method: "GET",
                headers: { Authorization: `Bearer ${data.token}` }, // 🛠 ارسال توکن
              });
          
              if (profileResponse.ok) {
                const profileData = await profileResponse.json();
                const userData = {
                  username: profileData.username,
                  avatar: profileData.imageAddress
                    ? `${API_BASE_URL}` + profileData.imageAddress
                    : "https://images.unsplash.com/photo-1488161628813-04466f872be2?fm=jpg&q=60&w=3000",
                };
                setUser(userData); // 🚀 ذخیره در `UserContext`
              }
            } catch (error) {
              console.error("Error retrieving user information:", error);
            }
            navigate("/");
        }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <motion.div
      className="image-generator-page"
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    >
    <div className="auth-container">
      <div className="auth-box">
        {/* 🔄 سوییچ بین لاگین و ریجستر */}
        <div className="tabs">
          <button className={isLogin ? "active" : ""} onClick={() => setIsLogin(true)}>
          Login
          </button>
          <button className={!isLogin ? "active" : ""} onClick={() => setIsLogin(false)}>
          Register
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {!isLogin && (
            <input type="text" name="username" placeholder="Username" value={formData.username} onChange={handleChange} required />
          )}
          <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
          <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
          {!isLogin && (
            <input type="password" name="confirmPassword" placeholder="Password confirmation" value={formData.confirmPassword} onChange={handleChange} required />
          )}

          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="auth-btn">{isLogin ? "Login" : "Register"}</button>
        </form>
      </div>
    </div>
    </motion.div>
  );
}

export default LoginRegister;
